import {NodeType, SetStyleConfig} from '../../../../submodules/map/mapiq-map/palette/types';
import {MaterialPreset} from '../../../../submodules/map/mapiq-map/palette/presets/types';

export const createSetStyleConfig = <T extends 'Map' | 'Record' = 'Map'>(
  config: SetStyleConfig<T>,
): SetStyleConfig<T> => {
  return config;
};
export const createSetStyleConfigOverrideEntry = (
  n: NodeType | string,
  p: MaterialPreset,
): [NodeType | string, MaterialPreset] => {
  return [n, p];
};
